import React from 'react';
import {Typography, CircularProgress} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone';
import {addFlashMessage} from '../../actions/flash-message';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Icon from '@material-ui/core/Icon';
import {Error as ErrorIcon} from '@material-ui/icons';
import {importQuiz} from '../../api/quiz';

export function QuizImport(props, context) {
    const { addFlashMessage } = props;
    const {router} = context;
    const [showProgress, setShowProgress] = React.useState(false);

    const DragHere = () => {
        return (
            <>
                <ImportIcon style={{height:'auto', width: 'auto'}}/>
                <Typography variant="h4" color="primary">Drag and Drop to Upload Your File</Typography>
                <Typography variant="h6" color="primary">Or</Typography>
                <Button color="secondary" variant="contained">Choose File</Button>
            </>
        );
    };

    const DropHere = () => {
        return (
            <div className="bordered">
                <ImportIcon style={{height:'auto', width: 'auto'}}/>
                <Typography variant="h4" color="primary">Drag and Drop to Upload Your File</Typography>
            </div>
        );
    };

    const IncorrectFileType = () => {
        return (
            <div className="bordered">
                <ErrorIcon color="error" style={{height:'6rem', width:'6rem'}}/>
                <Typography variant="h4" color="error">Incorrect file type</Typography>
            </div>

        );
    };

    const formatFileDataToSend = (file) => {
        const data = new FormData();
        data.append('zipfile', file, 'zipfile');
        return data;
    };

    const uploadZip = (zipFile) => {
        addFlashMessage('File accepted! Upload in progress', 'success');
        setShowProgress(true);
        const data = formatFileDataToSend(zipFile[0]);
        importQuiz(data).then( response => {
            router.history.push(`/quizzes/${response._id.$oid}/edit`);
            addFlashMessage('Successfully imported quiz', 'success');
        }).catch((err) => {
            addFlashMessage(`An error occurred during upload: ${err.message}`);
            setShowProgress(false);
        });

    };

    const rejectFile = (addFlashMessage) => {
        addFlashMessage('Invalid file - Only \'zip\' files accepted');
    };

    return (
        <>
            {!showProgress &&
            <Dropzone
                accept={["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"]}
                noKeyboard onDropAccepted={(acceptedFiles) => uploadZip(acceptedFiles)}
                onDropRejected={() => rejectFile(addFlashMessage)}>
                {({getRootProps, getInputProps, isDragActive, isDragAccept}) => (
                    <div className="center-all"
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} name="zipfile"/>
                        {
                            isDragActive ?
                                (
                                    isDragAccept ?
                                        DropHere() :
                                        IncorrectFileType()
                                ) :
                                DragHere()
                        }
                    </div>
                )}
            </Dropzone>}
            {showProgress &&
            <div className="center-all">
                <Typography variant="h4" color="primary">Please wait</Typography>
                <CircularProgress variant="indeterminate" color="secondary" size="3rem"/>
            </div>}
        </>
    );
}

const ImportIcon = (props) => { return (
    <Icon {...props}>
        <img src="/images/file_upload.png"/>
    </Icon>);
};

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizImport.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(QuizImport));
